import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["value"]

import {
  FormUnit,
  FormUnitRow,
  FormUnitCell,
  ButtonContainer,
  ButtonItem,
  SelectItem,
} from "@/components/modules";
import { ref, withDefaults, watch } from "vue";
import html2canvas from "html2canvas";

interface Props {
  isOpen: boolean;
}
const PIXEL_MM_RATE = 72 / 25.4;

/**
 * 画面開閉時処理
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'capture-display',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["showFrame", "hideFrame"],
  setup(__props: any, { emit }) {

const props = __props;





/**
 * サイズリスト
 */
const SIZE_LIST = ["A4縦", "A4横", "A3縦", "A3横", "全域"];

/**
 * サイズ
 */
const size = ref(null);

/**
 * 画像出力範囲決定用変数
 */
const CAPTURE_RANGE_RELATION = ref({
  HEADER_HEIGHT: 143,
  FOOTER_HEIGHT: 51,
  SIDE_MENU_WIDTH: 279,
  BORDER: 1,
});

/**
 * mmピクセル変換レート
 */
watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      showFrame(SIZE_LIST[4]);
      window.addEventListener("resize", () => {
        showFrame(size.value);
      });
    } else {
      hideFreame();
      window.removeEventListener("resize", () => {
        showFrame(size.value);
      });
    }
  }
);

/**
 * 画像出力
 */
const capture = async () => {
  let outputWidth = 0;
  let outputHeight = 0;
  const ratio = window.devicePixelRatio;
  CAPTURE_RANGE_RELATION.value = {
    HEADER_HEIGHT:
      document.getElementById("headerContent").scrollHeight +
      document.getElementById("toolHeader").scrollHeight,
    FOOTER_HEIGHT: document.getElementById("toolFooter").scrollHeight,
    SIDE_MENU_WIDTH: document.getElementById("sideMenu").scrollWidth,
    BORDER: 1 / ratio,
  };
  switch (size.value) {
    case "全域": {
      const element: HTMLElement = document.querySelector("#wholeContent");
      await html2canvas(element, {
        useCORS: true,
        allowTaint: true,
        foreignObjectRendering: false,
        scale: ratio,
      }).then((mapCanvas) => {
        let dw =
          document.documentElement.scrollWidth -
          CAPTURE_RANGE_RELATION.value.SIDE_MENU_WIDTH;
        let dh =
          document.documentElement.scrollHeight -
          CAPTURE_RANGE_RELATION.value.HEADER_HEIGHT -
          CAPTURE_RANGE_RELATION.value.FOOTER_HEIGHT;
        let correctionRatio = 0;
        if (dh >= dw) {
          correctionRatio = Math.min(297 / dh, 210 / dw);
        } else {
          correctionRatio = Math.min(297 / dw, 210 / dh);
        }
        const croppedCanvas = document.createElement("canvas");
        const ctx = croppedCanvas.getContext("2d");
        croppedCanvas.width = dw * correctionRatio * PIXEL_MM_RATE * 2;
        croppedCanvas.height = dh * correctionRatio * PIXEL_MM_RATE * 2;
        ctx.drawImage(
          mapCanvas,
          CAPTURE_RANGE_RELATION.value.SIDE_MENU_WIDTH * ratio,
          CAPTURE_RANGE_RELATION.value.HEADER_HEIGHT * ratio,
          dw * ratio,
          dh * ratio,
          0,
          0,
          croppedCanvas.width,
          croppedCanvas.height
        );
        const link = document.createElement("a");
        link.href = croppedCanvas.toDataURL();
        link.download = "image.png";
        link.click();
      });
      return;
    }
    case "A4縦":
      outputWidth = 210;
      outputHeight = 297;
      break;
    case "A4横":
      outputWidth = 297;
      outputHeight = 210;
      break;
    case "A3縦":
      outputWidth = 297;
      outputHeight = 420;
      break;
    case "A3横":
      outputWidth = 420;
      outputHeight = 297;
      break;
  }
  const frame = document.getElementById("captureFrame");
  const sx =
    (CAPTURE_RANGE_RELATION.value.BORDER +
      CAPTURE_RANGE_RELATION.value.SIDE_MENU_WIDTH +
      (document.documentElement.scrollWidth -
        CAPTURE_RANGE_RELATION.value.SIDE_MENU_WIDTH -
        frame.scrollWidth) /
        2) *
    ratio;
  const sy =
    (CAPTURE_RANGE_RELATION.value.BORDER +
      CAPTURE_RANGE_RELATION.value.HEADER_HEIGHT +
      (document.documentElement.scrollHeight -
        CAPTURE_RANGE_RELATION.value.HEADER_HEIGHT -
        CAPTURE_RANGE_RELATION.value.FOOTER_HEIGHT -
        frame.scrollHeight) /
        2) *
    ratio;
  const sw = frame.scrollWidth * ratio;
  const sh = frame.scrollHeight * ratio;
  const dw = outputWidth * PIXEL_MM_RATE;
  const dh = outputHeight * PIXEL_MM_RATE;
  const element: HTMLElement = document.querySelector("#wholeContent");
  await html2canvas(element, {
    useCORS: true,
    allowTaint: true,
    foreignObjectRendering: false,
    scale: ratio,
  }).then((mapCanvas) => {
    const croppedCanvas = document.createElement("canvas");
    const ctx = croppedCanvas.getContext("2d");
    croppedCanvas.width = dw;
    croppedCanvas.height = dh;
    ctx.drawImage(mapCanvas, sx, sy, sw, sh, 0, 0, dw, dh);
    const link = document.createElement("a");
    link.href = croppedCanvas.toDataURL();
    link.download = "image.png";
    link.click();
  });
};

/**
 * 枠表示
 */
const showFrame = (newSize: string) => {
  size.value = newSize;
  let rectWidth = 0;
  let rectHeight = 0;
  switch (size.value) {
    case "全域":
      hideFreame();
      return;
    case "A4縦":
    case "A3縦":
      rectWidth = 1;
      rectHeight = Math.sqrt(2);
      break;
    case "A4横":
    case "A3横":
      rectWidth = Math.sqrt(2);
      rectHeight = 1;
      break;
  }
  emit("showFrame", rectWidth, rectHeight);
};

/**
 * 枠非表示
 */
const hideFreame = () => {
  emit("hideFrame");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(FormUnit), { column: ['100px', '60px'] }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createTextVNode(" 出力画像サイズ： ")
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectItem), {
                  value: size.value,
                  onUpdate: showFrame
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SIZE_LIST, (ele) => {
                      return _createElementVNode("option", {
                        value: ele,
                        key: ele
                      }, _toDisplayString(ele), 9, _hoisted_1)
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ButtonContainer), { align: "right" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ButtonItem), { onClick: capture }, {
          default: _withCtx(() => [
            _createTextVNode("画像出力")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})